import * as React from 'react'

import { formatDateTime } from 'app/common/dateHelper'
import { TooltipLayout } from './ToolTipLayout'

type PlaceItemTooltipProps = {
  place: {
    startTime: string | Date
    endTime: string | Date
    entryType: string
    nation: string
    typeName: string
    color: string
  }
  translate: (text) => any
}
type PlaceItemTooltipState = {}

export class PlaceItemTooltip extends React.Component<
  PlaceItemTooltipProps,
  PlaceItemTooltipState
> {
  constructor(props: PlaceItemTooltipProps) {
    super(props)
  }

  render() {
    const { startTime, endTime, typeName, entryType, nation, color } =
      this.props.place

    const rows = [
      {
        title: this.props.translate('event.crossingType'),
        value: this.props.translate(`event.${entryType.toLocaleLowerCase()}`),
      },
      {
        title: this.props.translate('event.nation'),
        value: nation,
      },
      {
        title: this.props.translate('event.startTime'),
        value: formatDateTime(startTime),
      },
      {
        title: this.props.translate('event.endTime'),
        value: formatDateTime(endTime),
      },
    ]

    return (
      <TooltipLayout
        headerColor={color}
        headerTitle={this.props.translate(typeName).toString()}
        rows={rows}
      />
    )
  }
}
